import {
  ZONAS_INUNDABLES_LEGEND,
  formatZonasInundablesLegendLabel,
} from '../components/LayerSelectorPanel/MapLayerOptions';

const LEGEND_BY_VALUE = new Map(
  ZONAS_INUNDABLES_LEGEND.map((item) => [item.value, item]),
);

const NO_BAND_COLOR = 'rgba(255,255,255,0.55)';
const ZERO_RISK_COLOR = LEGEND_BY_VALUE.get(1)?.color ?? '#4daf4a';
/** 0 % mostrado cuando el API no envía `flood_risk_pct` (distinto de 0 % con dato). */
const MISSING_VALUE_COLOR = 'rgba(255,255,255,0.38)';

/** Parsea `flood_risk_pct` del detalle del lote (0–100). null = ausente en API. */
export const parseFloodRiskPct = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : Number(String(value).trim().replace(',', '.'));
  if (!Number.isFinite(n)) return null;
  return Math.min(100, Math.max(0, n));
};

/**
 * Nivel discreto según banda de `flood_risk_pct` (incidencia 1|2|3).
 * null si el valor está fuera de 70–79, 80–97 o 100.
 */
export const getFloodRiskLevel = (pct) => {
  const p = Math.round(pct);
  const match = ZONAS_INUNDABLES_LEGEND.find(
    (band) => p >= band.pctMin && p <= band.pctMax,
  );
  return match?.value ?? null;
};

export const getFloodRiskLevelMeta = (level) => (
  level != null ? (LEGEND_BY_VALUE.get(level) ?? null) : null
);

/** Texto del tooltip del panel según porcentaje y banda. */
export const buildFloodRiskTooltipMessage = ({ pctRounded, level = null }) => {
  const base = (
    `El lote se encuentra dentro de un radio censal donde el ${pctRounded}% `
    + 'de los hogares reportaron haber sufrido inundaciones'
  );
  if (level) return `${base} (nivel ${level}).`;
  return `${base}.`;
};

export const floodRiskBarColor = (pct) => {
  const level = getFloodRiskLevel(pct);
  if (level != null) {
    return LEGEND_BY_VALUE.get(level)?.color ?? '#9e9e9e';
  }
  return NO_BAND_COLOR;
};

/**
 * Presentación del riesgo de inundación para el panel del lote.
 */
export const getFloodRiskPanelDisplay = (value) => {
  const parsed = parseFloodRiskPct(value);
  const isMissing = parsed === null;
  const pct = parsed ?? 0;
  const pctRounded = Math.round(pct);
  const levelValue = isMissing ? null : getFloodRiskLevel(pct);
  const levelMeta = getFloodRiskLevelMeta(levelValue);
  const levelLabel = levelMeta?.label ?? null;

  const accentColor = isMissing
    ? MISSING_VALUE_COLOR
    : (levelMeta?.color ?? (pctRounded === 0 ? ZERO_RISK_COLOR : NO_BAND_COLOR));

  return {
    status: 'ready',
    isMissing,
    pct,
    pctLabel: `${pctRounded}%`,
    level: levelLabel,
    accentColor,
    tooltip: buildFloodRiskTooltipMessage({ pctRounded, level: levelLabel }),
  };
};

export { ZONAS_INUNDABLES_LEGEND, formatZonasInundablesLegendLabel };
